import axios from "axios";
import * as Sentry from "@sentry/react";

import store from "../app/store";
import { startLoading, stopLoading } from "../features/ui/uiSlice";
import json from "../secret.json";

const API_BASE_URL = json.API_BASE_URL;

const instance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// 화면을 덮는 '불러오는 중' 을 띄우지 않는 요청(isSilent). 쓰는 대로 뒤에서 저장하는 요청이 그렇다.
// 덮개가 뜨면 그동안 누른 단추가 먹히지 않는다(책 화면에서 칸을 쓰고 바로 '채점하기' 를 누르면 첫 클릭이 사라졌다).
instance.interceptors.request.use(
  (config) => {
    if (!config.isSilent) store.dispatch(startLoading());
    return config;
  },
  (error) => {
    store.dispatch(stopLoading());
    return Promise.reject(error);
  }
);

// 응답 인터셉터
instance.interceptors.response.use(
  (response) => {
    if (!response.config?.isSilent) store.dispatch(stopLoading());
    return response;
  },
  async (error) => {
    if (!error.config?.isSilent) store.dispatch(stopLoading());
    alert("오류가 발생했습니다.");
    Sentry.captureException(error);
    return Promise.reject(error);
  }
);

const apiClient = {
  async get(endpoint, config = {}) {
    const response = await instance.get(endpoint, config);
    return response;
  },

  async post(endpoint, data, config = {}) {
    const response = await instance.post(endpoint, data, config);
    return response;
  },

  async put(endpoint, data, config = {}) {
    const response = await instance.put(endpoint, data, config);
    return response;
  },

  async delete(endpoint) {
    const response = await instance.delete(endpoint);
    return response;
  },

  // put, delete 등 필요 시 추가
};

export default apiClient;
